// 计算两点间距离
const distance = (x0, y0, x1, y1) => Math.hypot(x1 - x0, y1 - y0);

// 生成指定范围的二维点位
const randomPosInRange = (min, max) => Array.from({length: 2}, () => Math.floor(Math.random() * (max - min + 1)) + min);

// 生成指定位数和范围的二维点位组合
const RPIRInCount = (min, max, n) => Array.from({length: n}, () => randomPosInRange(min, max));

// 计算各点的相互距离
const pointsDistance = (points) => {
    let array = [];
    for (let i = 0; i < points.length; i++) {
        for (let j = i + 1; j < points.length; j++) {
            const p1 = points[i];
            const p2 = points[j];
            array.push(distance(p1[0], p1[1], p2[0], p2[1]));
        }
    }
    return array
};

// 计算数组中的最小值
const minInArray = (array) => array.sort((a, b) => a - b)[0];

// 计算各点距离与最小距离的倍数
const distanceMultiple = (points) => {
    const distances = pointsDistance(points);
    // console.log('计算各点的相互距离',distances)
    const minDistance = minInArray(distances);
    const code = distances.map(distance => round(distance / minDistance, 5));
    code.shift();
    return code
};

// 四舍五入到指定位数
const round = (n, decimals = 0) => Number(`${Math.round(`${n}e${decimals}`)}e-${decimals}`);

// 差异相关性
const approximateMatchArray = (arr1, arr2) => {
    let scope = 0;
    arr1 = arr1.sort();
    arr2 = arr2.sort();
    const part = 100 / arr1.length;
    for (let i = 0; i < arr1.length; i++) {
        const reduce = Math.abs(arr1[i] - arr2[i]);
        const partScope = part * (1 - reduce / 10);
        scope = scope + partScope
    }
    let damping = 105;
    if (scope < 90) damping = 125;
    scope = scope * (scope / damping);
    if (scope > 100) scope = 0;
    return scope
};



// 余弦相似度
const cosSimilarity = async (x, y) => {
    x = tf.tensor2d(x);
    y = tf.tensor2d(y);
    const p1 = tf.sqrt(x.mul(x).sum());
    const p2 = tf.sqrt(y.mul(y).sum());
    let p12 = x.mul(y).sum();
    let score = p12.div(p1.mul(p2));
    score = ((await score.data())[0] - 0.9) * 10;
    return score
};

// 计算四边形的内角
const calculateAngles = (points) => {
    let angles = [];
    for (let i = 0; i < 4; i++) {
        let p1 = points[i];
        let p2 = points[(i + 1) % 4];
        let p3 = points[(i + 2) % 4];
        let angle = Math.atan2(p3[1] - p2[1], p3[0] - p2[0]) - Math.atan2(p1[1] - p2[1], p1[0] - p2[0]);
        angle = Math.abs(angle * 180 / Math.PI);
        if (angle > 180) angle = 360 - angle;
        angles.push(angle);
    }
    return angles;
};

// 主程序
export function check (code) {
    // let templateCode = [[100,100],[300,300],[100,300],[300,100]];
    // let templateCodeB = distanceMultiple(templateCode);
    //
    //
    // const codeB = distanceMultiple(code);
    // console.log("testCode2",templateCodeB,codeB)
    // const scope = approximateMatchArray(templateCodeB, codeB);
    // console.log('盖章scope',scope)
    // return scope>93;

    // 模板坐标
    let templateCode = [[100,100],[300,300],[100,300],[300,100]];
    let templateCodeB = distanceMultiple(templateCode);

    // 计算模板的面积、周长和角度
    let templatePointsDistanceData = pointsDistance(templateCode);
    templatePointsDistanceData.sort((a, b) => a - b);
    let templateMianJi = templatePointsDistanceData[0] * templatePointsDistanceData[1];
    let templateZhouChang = templatePointsDistanceData.reduce((a, b) => a + b, 0);
    let templateAngles = calculateAngles(templateCode);

    const codeB = distanceMultiple(code);
    const scope = approximateMatchArray(templateCodeB, codeB);
    // console.log("对比分数",scope)
    // 如果初步匹配通过，进行更严格的检查
    if (parseFloat(scope) >= 80) {
        let data = pointsDistance(code);
        data.sort((a, b) => a - b);

        // let mianji = data[0] * data[1];
        // let zhouchang = data.reduce((a, b) => a + b, 0);
        let angles = calculateAngles(code);

        // 检查面积、周长和角度
        // let areaDiff = Math.abs(mianji - templateMianJi) / templateMianJi;
        // let perimeterDiff = Math.abs(zhouchang - templateZhouChang) / templateZhouChang;
        let angleDiff = angles.reduce((sum, angle, i) => sum + Math.abs(angle - templateAngles[i]), 0) / 4;
        // console.log("内角",angleDiff)
        // console.log("data",data)
        // 设定更严格的阈值
        // if (angleDiff < 5 && data[0] > 100) {
        if (angleDiff <= 50) {
            return true;
        }
    }

    return false;

};

